<template>
  <div>
    <div class="row pt-3 l-m-b-20">
      <div class="col-9">
        <h1>Settlement templates</h1>
      </div>
      <div class="col-3 text-right">
        <button class="btn btn-primary" type="button" @click="toggleSidebar">
          ADD TEMPLATE
        </button>
      </div>
    </div>
    <template v-if="!templates">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>

    <template v-else>
      <table class="table m-table table-hover l-m-t-20">
        <thead class="m-table__heading">
          <tr>
            <th class="m-table__id">ID</th>
            <th>Name</th>
            <th>Subject</th>
            <th>Claim type</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="template in templates" @click="editTemplate(template.id, template.claim_types)" :key="template.id" class="pointer">
            <td>{{ template.id }}</td>
            <td>{{ template.name }}</td>
            <td>{{ template.subject }}</td>
            <td>
              <span v-for="(type, index) in template.claim_types"
                    :key="type.id"
              >
                {{ type.name }}<template v-if="index+1 < template.claim_types.length">, </template>
              </span>
            </td>
          </tr>
          <tr v-if="templates && !templates.length">
            <td colspan="4" class="text-center">
              No results found
            </td>
          </tr>
        </tbody>
      </table>
    </template>

    <!--  Create new settlement email template  -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showCreateSidebar">
        <create-email-template
          class="sidebar-right"
          @cancel="toggleSidebar()"
          @update="getAllClaimTypes"
          :email-template="template"
        />
      </div>
    </transition>

    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showEditSidebar">
        <edit-email-template
          class="sidebar-right"
          @cancel="toggleEditSidebar()"
          @update="getAllClaimTypes"
          :email-template="template"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import EditEmailTemplate from '../EditEmailTemplate';
import CreateEmailTemplate from '../CreateEmailTemplate';
import Errors from '../../../classes/Errors';

export default {
  components: {
    EditEmailTemplate,
    CreateEmailTemplate,
  },
  data: () => ({
    template: {
      type_id: 3,
      model_id: '',
      name: '',
      subject: '',
      body: '',
      claim_types: [],
      claim_type_ids: [],
    },
    claimTypes: [],
    filteredClaimTypes: [],
    templates: null,
    showCreateSidebar: false,
    showEditSidebar: false,
    loadingButton: false,
    buttonDisabled: false,
    errors: new Errors(),
  }),
  mounted() {
    this.getEmailTemplates();
    this.getClaimTypes();
  },
  methods: {
    getClaimTypes() {
      axios.get('/claims/types').then(res => {
        this.claimTypes = res.data.data;
      });
    },
    getEmailTemplates() {
      axios
        .get('claims/templates?type_id=3')
        .then(res => {
          this.templates = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    editTemplate(id, claimTypeIds) {
      [this.template] = this.templates.filter(template => template.id === id);
      const claimIds = [];
      claimTypeIds.filter(type => claimIds.push(type.id));
      this.template.claim_type_ids = [...claimIds];
      this.showEditSidebar = true;
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    toggleSidebar() {
      this.showCreateSidebar = !this.showCreateSidebar;
      this.getClaimTypes();
      this.getEmailTemplates();
    },
    toggleEditSidebar() {
      this.showEditSidebar = !this.showEditSidebar;
      this.getClaimTypes();
      this.getEmailTemplates();
    },
    updateClaimTypes(types) {
      const selectedTypes = [];
      types.forEach(type => {
        selectedTypes.push(type);
      });
      this.$set(this.template, 'claim_type_ids', selectedTypes);
    },
    getAllClaimTypes() {
      this.getEmailTemplates();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/Mailing/SettlementEmailTemplates.vue